
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral-prepare/1",
      function () {
        return require("private-next-pages/funeral-prepare/1.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral-prepare/1"])
      });
    }
  